<template>


<div v-if="shippingEdit" class="mt-2">
  <v-card style="padding: 15px;">
    <div style="font-size: 18px; font-weight: 700;">Shipper Details</div>

<div class="row">
  <div class="col-md-4">
<div>
  <span class="ship-title">Name:</span>
  <span class="ship-subtitle">{{ shipperForm.name }}</span>
</div>
  </div>
 <div class="col-md-4">
<div>
  <span class="ship-title">Country Code:</span>
  <span class="ship-subtitle">{{ shipperForm.countryCode  }}</span>
</div>
  </div>
   <div class="col-md-4">
<div>
  <span class="ship-title">Mobilenumber:</span>
  <span class="ship-subtitle">{{ shipperForm.number  }}</span>
</div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-4">
<div>
  <span class="ship-title">City:</span>
  <span class="ship-subtitle">{{ shipperForm.city }}</span>
</div>
  </div>
 <div class="col-md-4">
<div>
  <span class="ship-title">PostalCode:</span>
  <span class="ship-subtitle">{{shipperForm.postal }}</span>
</div>
  </div>
   <div class="col-md-4">
<div>
  <span class="ship-title">Email:</span>
  <span class="ship-subtitle">{{ shipperForm.email}}</span>
</div>
  </div>
</div>    

<div class="row mt-2">
  <div class="col-md-4">
<div>
  <span class="ship-title">Address1:</span>
  <span class="ship-subtitle">{{ shipperForm.address1 }}</span>
</div>
  </div>
 <div class="col-md-4">
<div>
  <span class="ship-title">Address1:</span>
  <span class="ship-subtitle">{{shipperForm.address1 }}</span>
</div>
  </div>
   <div class="col-md-4">
<div>
  <span class="ship-title">Company:</span>
  <span class="ship-subtitle">{{ shipperForm.company}}</span>
</div>
  </div>
</div>

  </v-card>
</div>

<div v-if="consignFormEdit" class="mt-2">
  <v-card style="padding: 15px;">
 <div style="font-size: 18px; font-weight: 700;">Consignee Details</div>
<div class="row">
  <div class="col-md-4">
<div>
  <span class="ship-title">Name:</span>
  <span class="ship-subtitle">{{ consignForm.name }}</span>
</div>
  </div>
 <div class="col-md-4">
<div>
  <span class="ship-title">Country Code:</span>
  <span class="ship-subtitle">{{ consignForm.countryCode  }}</span>
</div>
  </div>
   <div class="col-md-4">
<div>
  <span class="ship-title">Mobilenumber:</span>
  <span class="ship-subtitle">{{ consignForm.number  }}</span>
</div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-4">
<div>
  <span class="ship-title">City:</span>
  <span class="ship-subtitle">{{ consignForm.city }}</span>
</div>
  </div>
 <div class="col-md-4">
<div>
  <span class="ship-title">PostalCode:</span>
  <span class="ship-subtitle">{{consignForm.postal }}</span>
</div>
  </div>
   <div class="col-md-4">
<div>
  <span class="ship-title">Email:</span>
  <span class="ship-subtitle">{{ consignForm.email}}</span>
</div>
  </div>
</div>    

<div class="row mt-2">
  <div class="col-md-4">
<div>
  <span class="ship-title">Address1:</span>
  <span class="ship-subtitle">{{ consignForm.address1 }}</span>
</div>
  </div>
 <div class="col-md-4">
<div>
  <span class="ship-title">Address1:</span>
  <span class="ship-subtitle">{{consignForm.address1 }}</span>
</div>
  </div>
   <div class="col-md-4">
<div>
  <span class="ship-title">Company:</span>
  <span class="ship-subtitle">{{ consignForm.company}}</span>
</div>
  </div>
</div>

  </v-card>
</div>


  <div class="overlay bg-white pt-3 pb-4 ps-5 pe-5 mt-3">
        <div class="overlay-content-booking">
          <div class="demo-space-y" />



          <div>
            <div  v-if="form1">
              <v-form ref="form" v-model="valied1" @submit="shippingDetail">
                <div class="shipperDetail">
                  <VCol cols="12" md="12" sm="12">
                    <div class="d-flex align-center">
                      <div>
                        <VBtn
                          color="#1F1F45"
                          block
                          style="border-radius: 50%; width: 40px; height: 40px"
                        >
                          <b>1</b>
                        </VBtn>
                      </div>

                      <div style="margin-inline-start: 10px">
                        <div class="label-head">SHIPPER DETAILS</div>
                        <p class="label-sub m-0">Setup Shipper Details</p>
                      </div>
                    </div>
                  </VCol>
                  <VCol cols="12" style="margin-block-start: -20px">
                    <VDivider />
                  </VCol>

                  <div class="row">
                    <div class="col-md-4">
                      <label>NAME</label>

                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.name"
                        required
                        :rules="overallFormValidation"
                        variant="outlined"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4 textfield">
                      <label class="label-title">COUNTRY CODE</label>
                      <div>
                        <v-autocomplete
                          :items="countrycode"
                          class="login-form551"
                          item-title="name"
                          variant="outlined"
                          width="auto"
                          v-model="shipperForm.countryCode"
                          :rules="overallFormValidation"
                        >
                        </v-autocomplete>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">MOBILE</label>

                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.number"
                        required
                        type="number"
                        :rules="mblRules"
                        variant="outlined"
                        length="14"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 1</label>

                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.address1"
                        required
                        :rules="overallFormValidation"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 2 </label>
                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.address2"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 3 </label>
                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.address3"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">COMPANY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.company"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">CITY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.city"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">POSTAL CODE/ LOCATION</label>
                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.postal"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4 textfield">
                      <label class="label-title">EMAIL</label>

                      <v-text-field
                        class="login-form551"
                        v-model="shipperForm.email"
                        required
                        :rules="EmailValid"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row w-100">
                    <div class="col-6">
                      <VBtn
                        color="#1F1f45"
                        width="200px"
                        @click="sendParent()"
                      >
                        BACK
                      </VBtn>
                    </div>
                    <div
                      class="col-6"
                      style="display: flex; justify-content: end"
                    >
                      <VBtn  color="#1F1F45" type="submit" width="200px">
                        NEXT
                      </VBtn>
                    </div>
                  </div>
                </div>
              </v-form>
            </div>
<!-- --------form 1 end------- -->


<!-- --------form 2 start------- -->
            <div v-if="form2">
              <v-form ref="form" v-model="valied2" @submit="shippingDetail2">
                <div class="shipperDetail">
                  <VCol cols="12" md="12" sm="12">
                    <div class="d-flex align-center">
                      <div>
                        <VBtn
                          color="#1F1F45"
                          block
                          style="border-radius: 50%; width: 30px; height: 30px"
                        >
                          <b>2</b>
                        </VBtn>
                      </div>

                      <div style="margin-inline-start: 10px">
                        <div class="label-head">CONSIGNEE DETAILS</div>
                        <p class="label-sub m-0">Setup Consignee Details</p>
                      </div>
                    </div>
                  </VCol>
                  <VCol cols="12" style="margin-block-start: -20px">
                    <VDivider />
                  </VCol>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">NAME</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.name"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4 textfield">
                      <label class="label-title">COUNTRY CODE</label>
                      <div>
                        <v-autocomplete
                          :items="countrycode"
                          :rules="overallFormValidation"
                          class="login-form551"
                          item-title="name"
                          variant="outlined"
                          width="auto"
                          v-model="consignForm.countryCode"
                        >
                        </v-autocomplete>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">MOBILE</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.number"
                        variant="outlined"
                        type="number"
                        required
                        :rules="overallFormValidation"
                        length="14"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 1</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.address1"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 2</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.address2"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">ADDRESS 3</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.address3"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">COMPANY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.company"
                        variant="outlined"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <label class="label-title">CITY</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.city"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>

                    <div class="col-md-4">
                      <label class="label-title">POSTAL CODE/ LOCATION</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.postal"
                        variant="outlined"
                        required
                        :rules="overallFormValidation"
                      ></v-text-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <label class="label-title">EMAIL</label>
                      <v-text-field
                        class="login-form551"
                        v-model="consignForm.email"
                        variant="outlined"
                        required
                        :rules="EmailValid"
                      ></v-text-field>
                    </div>
                  </div>

                  <div class="row w-100">
                    <div class="col-6">
                      <VBtn
                        color="#1F1f45"
                        width="200px"
                         @click="toggleView('form1')"
                      >
                        BACK
                      </VBtn>
                    </div>
                    <div
                      class="col-6"
                      style="display: flex; justify-content: end"
                    >
                      <VBtn  color="#1F1F45" width="200px" type="submit">
                        NEXT
                      </VBtn>
                    </div>
                  </div>
                </div>
              </v-form>
            </div>
            <!-- --------form 2 end------- -->


            <!-- --------form 3 start------- -->

            <div v-if="form3">
              <VRow class="p-2">
                <VCol cols="12" md="12" sm="12">
                  <div class="d-flex align-center">
                    <div>
                      <VBtn
                        color="#1F1F45"
                        block
                        style="border-radius: 50%; width: 30px; height: 30px"
                      >
                        <b>3</b>
                      </VBtn>
                    </div>

                    <div style="margin-inline-start: 10px">
                      <div class="label-head">SHIPMENT DETAILS</div>
                      <p class="label-sub m-0">Setup Shipment Details</p>
                    </div>
                  </div>
                </VCol>
                <VCol cols="12" style="margin-block-start: -20px">
                  <VDivider />
                </VCol>
                <div class="row w-100">
                  <div class="col-md-6">
                    <label class="label-title">ESTIMATED PICKUP DATE</label>
                    <VueDatePicker
                      v-model="bookingPickupdate"
                      :min-date="new Date()"
                      auto-apply
                      placeholder="Select Date"
                      :on-click-outside="ClickOutDepat"
                      :month-change-on-scroll="false"
                      :enable-time-picker="false"
                    >
                    </VueDatePicker>
                  </div>
                  <div class="col-md-6">
                    <label class="label-title">ENTER CONTENT DESCRIPTION</label>
                    <v-text-field
                      class="login-form551"
                      v-model="bookingcontentDescription"
                      variant="outlined"
                      required
                    ></v-text-field>
                  </div>
                </div>

                <VCol cols="5" md="5" sm="5" />
                <VCol md="3" lg="3">
                  <VBtn
                    color="#1F1F45"
                    block
                    width="200px"
                   @click="toggleView('form2')"
                  >
                    BACK
                  </VBtn>
                </VCol>
                <VCol md="3" lg="3">
                  <VBtn :disabled="loader" color="#1F1F45" block type="submit" @click="getEmail()">
                    <VProgressCircular
                      v-if="loader"
                      color="white"
                      indeterminate
                    />
                    PROCEED
                  </VBtn>
                </VCol>
              </VRow>
            </div>
          </div>

          <!-- --------form 2 end------- -->
        </div>
      </div>


<v-dialog v-model="getEmailRes" persistent>
        <div class="p-4 text-center bg-white m-auto"  style="    border-radius: 10px;">
          <div style="font-size: 17px; font-weight: 500">
            Reference ID:
            <span style="font-weight: 700">{{ bookingRefId || this.$route.query.quoteRequest_id }}</span>
            
          </div>
          <h3>Thank you for your request.</h3>
          <h5>Our representative will contact with you soon.</h5>
          <div class=" mt-4 text-center">
             <v-btn class="but-color" style="width:200px" @click="$router.push('/')"> Get Quote </v-btn>
          </div>
        </div>
      </v-dialog>

</template>

<script >
import axios from "axios";
// import VueDatePicker from "@vuepic/vue-datepicker";
import country1 from "@/coundtrycode.json";
export default{
   props: {
    getFormvalue: {
      type: Array,
      required: true
    }
  },
    data (){
    return{

      bookingRefId:"",
      getEmailRes:false,
      overallFormValidation: [(v) => !!v || "Please enter a valid input"],
      EmailValid: [
        v => !!v || "Email is required",
        v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Enter a valid email",
      ],
      mblRules: [
        v => !!v || "Mobile number is required",
        v => /^[0-9]+$/.test(v) || "Only digits allowed",
        v => (v && v.length >= 6) || "Enter at least 6 digits"
      ],
       bookingPickupdate:"",   
       bookingcontentDescription:"",  
      formvalueData :{},
       form1:true,
        form2:false,
        form3:false,
        loader:false,
        shipId:"",
        valied1:false,
        valied2:false,
        consignFormEdit:false,
        shippingEdit:false,
        countrycode: [],
        shipperForm:{
name:"",
countryCode:"",
number:"",
address1:"",
address2:"",
address3:"",
company:"",
city:"",
postal:"",
email:""

        },
         consignForm:{
name:"",
countryCode:"",
number:"",
address1:"",
address2:"",
address3:"",
company:"",
city:"",
postal:"",
email:""

        },
        quoteSelected:{},
    }
},
created(){
this.formvalueData =this.getFormvalue
if(this.formvalueData?.fromPostal){
this.shipperForm.postal=this.formvalueData?.fromPostal || ""
this.shipperForm.city=this.formvalueData?.fromcity || ""
this.shipperForm.name=this.formvalueData?.passDeatils?.Name ||""
this.shipperForm.email=this.formvalueData?.passDeatils?.Email ||""
this.shipperForm.number=this.formvalueData?.passDeatils?.Contact ||""

this.consignForm.postal=this.formvalueData?.toPostal || ""
this.consignForm.city=this.formvalueData?.tocity || ""
}

console.log(this.getFormvalue,'this.getFormvalue')

},
mounted() {

    country1.forEach((v) => {
      let obj = {
        name: `${v.dial_code} ${v.name}`,
        code: v.dial_code,
      };
      this.countrycode.push(obj);
      
    });
   
    setTimeout(()=>{
    
       this.countrycode.forEach((c)=>{
        if(c.name.includes(this.formvalueData .fromCountry)){
          this.shipperForm.countryCode=c.name
          
        }
        if(c.name.includes(this.formvalueData.toCountry)){
          this.consignForm.countryCode=c.name
        }
       })
   console.log(this.countrycode,this.shipperForm,this.formvalueData,'this.countrycode')
    },2000)
  },
methods:{
  toggleView(val){
    this.form1=false
     this.form2=false
      this.form3=false

      this[val]=true
  },
   shippingDetail() {
      console.log(this.valied1, "valied1");
      if (this.valied1) {
        this.toggleView('form2')
        this.shippingEdit=true
      }
    },
    shippingDetail2() {
      console.log(this.valied1, "valied1");
      if (this.valied2) {
        this.toggleView('form3')
         this.consignFormEdit=true
      }
    },
    sendParent(){
         this.$emit("updateValue", 'formResponceData'); 
    },

    async getEmail() {
      
      this.shipId = this.$route.query.quoteRequest_id;
      if (
        this.valied1 &&
        this.valied2 &&
        this.bookingcontentDescription &&
        this.bookingPickupdate &&
        this.bookingcontentDescription &&
        this.bookingPickupdate
      ) {
        this.loader = true;
         this.quoteSelected= this.formvalueData?.quoteSelected
        let $getEmail = {
          formId: this.shipId,
          quoteselectedId:this.formvalueData?.quoteselectedId, 
          quoteSelected: {
            IsCodApplicable: this.quoteSelected.IsCodApplicable,
            TopayCharges: this.quoteSelected.TopayCharges,
            CodCharges: this.quoteSelected.CodCharges,
            ODACharges: this.quoteSelected.ODACharges,
            DocketCharge: this.quoteSelected.DocketCharge,
            FreightRate: this.quoteSelected.FreightRate,
            Weight: this.quoteSelected.Weight,
            CompanyId: this.quoteSelected.CompanyId,
            CarrierName: this.quoteSelected.CarrierName,
            ServiceName: this.quoteSelected.ServiceName,
            ServiceId: this.quoteSelected.ServiceId,
            CarrierId: this.quoteSelected.CarrierId,
            DocType: this.quoteSelected.DocType,
            maxPrice: this.quoteSelected.maxPrice,
            minPrice: this.quoteSelected.minPrice,
            GrandTotal: this.quoteSelected.GrandTotal,
            SubTotal: this.quoteSelected.SubTotal,
            IsError: this.quoteSelected.IsError,
            TaxName1: this.quoteSelected.TaxName1,
            TaxAmount1: this.quoteSelected.TaxAmount1,
            TaxName2: this.quoteSelected.TaxName2,
            TaxAmount2: this.quoteSelected.TaxAmount2,
            TaxName3: this.quoteSelected.TaxName3,
            TaxAmount3: this.quoteSelected.TaxAmount3,
            TaxName4: this.quoteSelected.TaxName4,
            TaxAmount4: this.quoteSelected.TaxAmount4,
            TotalTax: this.quoteSelected.TotalTax,
            OrgLcnId: this.quoteSelected.OrgLcnId,
            DestLcnId: this.quoteSelected.DestLcnId,
            FuelSurcharge: this.quoteSelected.FuelSurcharge,
            Othercharges: this.quoteSelected.Othercharges,
            RateEntryType: this.quoteSelected.RateEntryType,
            CovidCharge: this.quoteSelected.CovidCharge,
            VolumetricWgtDenominator:
              this.quoteSelected.VolumetricWgtDenominator,
            IsSpotRate: this.quoteSelected.IsSpotRate,
            FOVType: this.quoteSelected.FOVType,
            FOVCharge: this.quoteSelected.FOVCharge,
            DeliveryDate: this.quoteSelected.DeliveryDate,
            CarrierLogo: this.quoteSelected.CarrierLogo,
            IsAWBChargesApplicable: this.quoteSelected.IsAWBChargesApplicable,
            ToPayApplicable: this.quoteSelected.ToPayApplicable,
            AWBCharges: this.quoteSelected.AWBCharges,
            no_of_days_to_deliver: this.quoteSelected.no_of_days_to_deliver,
          },

          bookingformdata: {
            Sendername: this.shipperForm.name,
            Receivername: this.consignForm.name,
            Senderemail: this.shipperForm.email,
            Receiveremail:this.consignForm.email,
            Senderdialcode: this.shipperForm.countryCode,
            Receiverdialcode: this.consignForm.countryCode,
            Sendercompany: this.shipperForm.company,
            Receivercompany: this.consignForm.company,
            Sendermobile: this.shipperForm.number,
            Receivermobile:this.consignForm.number,
            Senderaddress1: this.shipperForm.address1,
            Receiveraddress1:this.consignForm.address1,
            Senderaddress2: this.shipperForm.address2,
            Receiveraddress2: this.consignForm.address2,
            Senderaddress3:this.shipperForm.address3,
            Receiveraddress3: this.consignForm.address3,
            Sendercity: this.shipperForm.city,
            Receivercity:  this.consignForm.city,
            Senderzipcode:this.shipperForm.postal,
            Receiverzipcode: this.consignForm.postal,
            
            bookingPickupdate: this.bookingPickupdate,
            bookingcontentDescription: this.bookingcontentDescription,
          },
        };
console.log($getEmail,'$getEmail')
        try {
          const response = await axios.post(
            `https://connect.Majesticcourier.com/api/getQuoteMail2`,
            $getEmail,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
           this.bookingRefId = response.data.booking_reference_id;
           this.loader= false;
            this.getEmailRes = true;
         
          console.log(response, "responseresponse333$getEmail");
        } catch (e) {
          console.log(e, "error");
        }

        // console.log($getEmail, "$getEmail ");
      }
    },

},


}

</script>

<style scoped>

.ship-title {
    font-size: 14px !important;
    font-weight: 700 !important;
}.ship-subtitle {
    font-weight: 500 !important;
    font-size: 14px !important;
    margin-left: 4px;
}
.v-autocomplete__selection-text,
.v-select__selection-text {
  padding-block: 10px;
  padding-inline: 0;
}

.v-autocomplete--single.v-text-field input {
  inset-block-start: 24px;
}

.formelements .v-label {
  font-size: 12px !important;
  font-weight: 1000 !important;
}

.v-table {
  box-shadow: 0 2px 6px rgba(var(--v-shadow-key-umbra-color), 0.14),
    0 0 transparent, 0 0 transparent;
  padding-block: 15px;
  padding-inline: 5px;
}

.v-table th {
  line-height: 1;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
  appearance: none;
}

/* Firefox */
input[type="number"] {
  appearance: textfield;
}


>>> .login-form551 .v-field {
  height: 42px !important;
}
>>> .login-form551 .v-field__prepend-inner {
  height: 42px !important;
}
>>> .login-form551 .v-field__field {
  height: 42px !important;
}
>>> .login-form551 .v-field__input {
  padding-top: 0 !important;
}
>>>.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--active input {
    transition: none;
    top: 0px;
}

>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
        background: none !important;
}
>>>.postal-form .v-field__input {
    top: -2px !important;
}
</style>